<template>
  <div :class="{ [view]: true, [type]: true }">
    <svgicon
      v-if="view == 'popup'"
      :icon="icon"
      width="20"
      style="min-width: 20px"
    />

    <div class="popup__content">
      <b>{{ title }}</b>
      <span>{{ text }}</span>
    </div>

    <svgicon
      v-if="false"
      @click="$emit('close')"
      icon="clear"
      width="18"
      class="clear__icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Ошибка",
    },
    text: {
      type: String,
      default: "Повторите попытку позже.",
    },
    type: {
      type: String,
      default: "error",
    },
    view: {
      type: String,
      default: "popup",
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case "error":
          return "warn";
        case "success":
          return "success";
        case "info":
          return "info";
        default:
          return "warn";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.alert,
.popup {
  display: flex;
  align-items: flex-start;
  width: 300px;
  max-height: 87px;
  overflow: auto;
  padding: 13px 6px;
  position: fixed;
  border-radius: 4px;
  bottom: 20px;
  right: 20px;
  z-index: 1000;

  .popup__content {
    display: flex;
    flex-direction: column;
    margin-left: 9px;
    max-width: 100%;
    height: 100%;

    &::-webkit-scrollbar {
      width: 4px;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 66, 105, 0.06);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 66, 105, 0.24);
      border-radius: 4px;
    }

    b {
      line-height: 120%;
    }
  }

  .clear__icon {
    position: absolute;
    right: 19px;
    top: 13px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}

.alert {
  box-shadow: 0px 4px 4px rgba(0, 32, 51, 0.04),
    0px 8px 24px rgba(0, 32, 51, 0.12);
  color: black;
  border-left: 8px solid;
  background: white;

  &.error {
    border-color: $red;
  }

  &.success {
    border-color: $green;
  }

  &.info {
    border-color: $orange;
  }
}

.popup {
  color: white;
  fill: white;

  &.error {
    background: $red;
  }

  &.success {
    background: $green;
  }

  &.info {
    background: $orange;
  }
}
</style>
